import {Box, Heading, Image, Link as ChakraLink} from '@chakra-ui/react';
import React, { useState } from 'react';
import { API_GET_ENDPOINTS } from '../../../api/ApiConfig';
import LoadingWidget from "../../parts/LoadingWidget";

const Login: React.FC = () => {
    const [load, setLoad] = useState(false);
    
    setTimeout(() => setLoad(true), 1000);

    
    if (!load) return <LoadingWidget withImage={true} image="url('/images/forest.jpg')" />
    return (
    <Box
        height="100vh"
        width="100vw"
        backgroundImage="url('/images/forest.jpg')"
        backgroundSize="cover"
        backgroundPosition="center"
        display="flex"
        justifyContent="center"
        alignItems="center"
    >
        <Box
            bg="white"
            padding="5"
            borderRadius="md"
            boxShadow="lg"
            textAlign="center"
            width="sm"
            display="flex"
            flexDirection="column"
            alignItems="center"
        >
            <ChakraLink href="https://zhr.pl/">
                <Image
                    src="logo512.png"
                    alt="Logo"
                    boxSize="300px"
                />
            </ChakraLink>
            <Box
                padding="3"
            >
                <a
                    href={API_GET_ENDPOINTS.REDIRECT_TO_GOOGLE}
                    style={{
                        display: "inline-block",
                        fontSize: "20px",
                        fontWeight: "bold",
                        padding: "15px 120px",
                        backgroundColor: "#134152",
                        color: "white",
                        borderRadius: "10px",
                        textDecoration: "none",
                        textAlign: "center",
                        transition: "background 0.3s",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3b73c4")}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#4c84d9")}
                >
                    Logowanie
                </a>
            </Box>
        </Box>
    </Box>
    );
};


export default Login;